export enum Endpoints {
  INIT = '/api/v1/quote/init',
  WARRANTY_SELECTION = '/api/v1/quote/warranty-selection',
  LOOKUP_JSON = '/api/v1/lookup/json',
  LOOKUP_HTML = '/api/v1/lookup/html',
  ABOUT = '/api/v1/about',
  UPDATE_FIELD = '/api/v1/quote/update-field',
  CHANGE_FIELD = '/api/v1/quote/change-field',
  CHANGE_PHONE = '/api/v1/quote/update-data-page/change-phone',
  UPDATE_CONFIGURATION = '/api/v1/quote/update-configuration',
  UPDATE_DATA = '/api/v1/quote/update-data',
  RESET_CONFIGURATION = '/api/v1/quote/reset-config',
  SET_AGENCY = '/api/v1/quote/set-agency',
  LEAD_SAVE = '/api/v1/lead/save',
  LEAD_UPDATE = '/api/v1/lead/update',
  SAVE = '/api/v1/quote/save',
  SEND = '/api/v1/quote/send',
  CHECK_PHONE = '/api/v1/quote/check-phone',
  OTP_SEND = '/api/v1/otp/send',
  OTP_VALIDATE = '/api/v1/otp/validate',
  BUY = '/api/v1/quote/buy',
  BUY_GDPR = '/api/v1/quote/buy-GDPR',
  GET_CONFIGURATION = '/api/v1/quote/get-configuration',
  RESTORE_CONFIGURATION = '/api/v1/quote/restore-configuration',
  RECOVER = '/api/v1/quote/recover',
  UPDATE_ADDRESS = '/api/v1/quote/update-address',
  UPDATE_PAGE_CONTRACTOR = '/api/v1/quote/update-data-page/contractor?page=CONTRACTOR',
  UPDATE_PAGE_CONFIGURATOR = '/api/v1/quote/update-data-page/default?page=CONFIGURATOR',
  UPDATE_PAGE_VEHICLE = '/api/v1/quote/update-data-page/default?page=VEHICLE',
  UPDATE_PAGE_DELIVERY = '/api/v1/quote/update-data-page/delivery?page=DELIVERY',
  UPDATE_PAGE_VEHICLE_CONFIGURATOR = '/api/v1/quote/update-data-page/vehicle-conf?page=VEHICLECONFIGURATOR',
  ADD_BLUESKY_DISCOUNT = '/api/v1/quote/discount',
  STATUS_BLUESKY_DISCOUNT = '/api/v1/quote/discount/status',
  GET_FIELD_OPTIONS = '/api/v1/quote/get-field-options',
  AEM_RESOURCE = '/api/v1/lookup/aem-resource',
  SELECT_OPTIONAL = '/api/v1/quote/optionals'
}
export enum GeoservicesEndpoints {
  AGENCY_DETAILS = '/ecomm/detailbycod/agenzie',
  AGENCY_MARKERS = '/ecomm/bybounds/agenzie',
  AGENCY_BYDIST = '/ecomm/bydist/agenzie',
  AGENCY_BLUESKY = '/ecomm/blueskybydist/agenzie',
}
